import { render, staticRenderFns } from "./PresentationThumbnail.vue?vue&type=template&id=3d8c2e0c"
import script from "./PresentationThumbnail.vue?vue&type=script&lang=js"
export * from "./PresentationThumbnail.vue?vue&type=script&lang=js"
import style0 from "./PresentationThumbnail.vue?vue&type=style&index=0&id=3d8c2e0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports